export default {
  props: {
    icon: String,
    desc1: String,
    desc2: String
  }
};